import differenceInSeconds from 'date-fns/differenceInSeconds';
import parseISO from 'date-fns/parseISO';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export default function useFailsafeTimerComplete(onTimerComplete, endAt, disabled = false) {
    const endTimeoutRef = useRef(null);
    const endAtDate = useMemo(() => (endAt !== null ? parseISO(endAt) : null), [endAt]);
    const [timerComplete, setTimerComplete] = useState(false);
    const onComplete = useCallback(() => {
        if (endTimeoutRef.current !== null) {
            clearTimeout(endTimeoutRef.current);
            endTimeoutRef.current = null;
        }
        setTimerComplete(true);
        onTimerComplete();
    }, [onTimerComplete]);

    useEffect(() => {
        if (disabled) {
            return;
        }
        const seconds = endAt !== null ? differenceInSeconds(endAtDate, new Date()) + 1 : 0;
        if (seconds <= 0 || timerComplete) {
            return () => {};
        }
        endTimeoutRef.current = setTimeout(() => {
            onTimerComplete();
        }, seconds * 1000);
        return () => {
            clearTimeout(endTimeoutRef.current);
            endTimeoutRef.current = null;
        };
    }, [endAtDate, onTimerComplete, timerComplete, disabled]);

    return onComplete;
}
